"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var PREDEFINED_FONT_FAMILIES = {
    native: [
        'Arial',
        'Verdana',
        'Helvetica',
        'Tahoma',
        'Trebuchet MS',
        'Times new Roman',
        'Georgia',
        'Garamond',
        'Courier New'
    ],
    google: [
        'Roboto',
        'Open Sans',
        'Noto Sans JP',
        'Lato',
        'Montserrat',
        'Poppins',
        'Source Sans Pro',
        'Roboto Condensed',
        'Oswald',
        'Roboto Mono',
        'Raleway',
        'Noto Sans',
        'Ubuntu',
        'Inter',
        'Nunito',
        'Roboto Slab',
        'PT Sans',
        'Merriweather',
        'Playfair Display',
        'Noto Sans KR',
        'Rubik',
        'Mukta',
        'Nunito Sans',
        'Work Sans',
        'Lora',
        'Noto Sans TC',
        'Fira Sans',
        'Nanum Gothic',
        'Barlow',
        'Titillium Web',
        'Inconsolata',
        'Tangerine',
        'Comfortaa',
        'Didact Gothic',
        'Jura',
        'Advent Pro',
        'Alegreya Sans',
        'Skranji',
        'Philosopher',
        'Lobster',
        'Antic Slab',
        'Arimo',
        'Bad Script',
        'Baumans',
        'Bevan',
        'Black Ops One',
        'Damion',
        'Fredoka One',
        'Graduate',
        'Josefin Slab',
        'Lusitana',
        'Molengo',
        'Parisienne',
        'Qwigley',
        'Rock Salt',
        'Rokkitt',
        'Rye',
        'Sacramento',
        'Satisfy',
        'The Girl Next Door',
        'Poiret One',
        'Yanone Kaffeesatz',
        'Dancing Script',
        'Cookie',
        'Calligraffitti',
        'Marvel',
        'Karma',
        'Belleza',
        'Anton',
        'Fjalla One',
        'Encode Sans Condensed',
        'Pacifico',
        'Ubuntu Condensed',
        'Raleway Dots',
        'Reenie Beanie'
    ],
    europa: ['Europa'],
    berlin: ['Berlin']
};
var styleDetection = function (campaign) {
    var extractedFonts = [];
    function dedup(arr) {
        return arr.filter(function (v, i) { return arr.indexOf(v) === i; });
    }
    function extractFonts(predicate) {
        var result = predicate.match(/style="(.*?)">/g) || [];
        return result
            .filter(function (r) { return r.includes('font-family'); })
            .map(function (r) { return r.replace('style="font-family: ', '').replace('">', '').trim(); });
    }
    function traverse(item) {
        if (item !== null && typeof item === 'object') {
            Object.entries(item).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                // key is either an array index or object key
                var f = [];
                if (key === 'fontFamily')
                    f.push("" + value);
                if (key === 'text')
                    f = f.concat(extractFonts("" + value) || []);
                extractedFonts = extractedFonts.concat(f);
                traverse(value);
            });
        }
    }
    traverse(campaign);
    return dedup(extractedFonts);
};
var styleInjection = function (familyName, userID, url) {
    if (url === void 0) { url = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var source;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    source = 'custom';
                    if (PREDEFINED_FONT_FAMILIES.native.includes(familyName))
                        return [2 /*return*/];
                    if (PREDEFINED_FONT_FAMILIES.google.includes(familyName))
                        source = 'google';
                    if (PREDEFINED_FONT_FAMILIES.europa.includes(familyName))
                        source = 'europa';
                    if (PREDEFINED_FONT_FAMILIES.berlin.includes(familyName))
                        source = 'berlin';
                    return [4 /*yield*/, injectFontFamily(familyName, userID, source, url)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
var injectFontFamily = function (familyName, userID, source, url) {
    if (url === void 0) { url = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var encodedFamily, id, res, json, j, f;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    encodedFamily = encodeURIComponent(familyName.trim());
                    id = "socital-script-" + familyName.replace(/\s+/g, '');
                    if (document.querySelector("link#" + id))
                        return [2 /*return*/];
                    return [4 /*yield*/, fetch(url + "/api/v1/font?familyName=" + encodedFamily + "&source=" + source + "&userID=" + userID)];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    j = document.createElement('link');
                    f = document.getElementsByTagName('head')[0];
                    j.async = true;
                    j.defer = true;
                    j.id = id;
                    j.href = json.fontSource;
                    j.rel = 'stylesheet';
                    j.type = 'text/css';
                    f.appendChild(j);
                    return [2 /*return*/];
            }
        });
    });
};
exports.default = { styleDetection: styleDetection, styleInjection: styleInjection, PREDEFINED_FONT_FAMILIES: PREDEFINED_FONT_FAMILIES };
//# sourceMappingURL=data:application/json;base64,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